// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__37c8t","actions":"GroupTable_actions__LJR3_","deleteModalFooter":"GroupTable_deleteModalFooter__3oMez"};